import React, { FunctionComponent } from 'react';
import { ISvgProps } from '../../models/inner-models';

export const ArrowDropDownIcon: FunctionComponent<ISvgProps> = ({className}) => (
  <svg className={className} width="24" height="24" focusable="false" aria-hidden="true" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 10l5 5 5-5z"></path>
  </svg>
);
